<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div v-loading="loading">
      <div class="button_wrap">
        <span
          ><h4>{{ language("shopBanners.breadcrumbTitle") }}</h4></span
        >
        <template v-if="$menuList['SIS-ShopDisplay-Banner-Add']">
          <el-button type="primary" @click="open">{{
            language("shopBanners.add")
          }}</el-button>
        </template>
      </div>
      <el-divider></el-divider>
      <div class="count_tips">
        <div>
          {{ language("shopBanners.results") }} {{ results }}
          {{ language("shopBanners.rows") }}
        </div>
        <page :total="results" @pageChange="pageChange"></page>
      </div>
      <cc-table
        :loadData="false"
        :dataArr="dataArr"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        :buttonsWidth="buttonsWidth"
        :emptyText="language('shopBanners.emptyText')"
        :showIndex="false"
      ></cc-table>
    </div>

    <el-dialog
      :title="language('shopBanners.breadcrumbTitle')"
      :visible.sync="dialog"
      :close-on-click-modal="false"
      width="90%"
    >
      <template v-if="dialog">
        <banners-edit @success="success" :editData="editData"></banners-edit>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import bannersEdit from "./components/bannersEdit";
import page from "../../components/page";

export default {
  components: {
    breadcrumb,
    bannersEdit,
    page,
  },
  data() {
    return {
      loading: true,
      breadcrumb: {
        title: this.language("shopBanners.breadcrumbTitle"),
        list: [
          {
            name: this.language("shopBanners.breadcrumbList_1"),
          },
          {
            name: this.language("shopBanners.breadcrumbList_2"),
          },
        ],
      },
      table: {
        api: "admin/merchant/shop/banner/query",
        showPager: false,
        columns: [
          {
            prop: "id",
            lable: "ID",
            minWidth: 230,
          },
          {
            prop: "shopNum",
            lable: this.language("shopBannerForm.shopNum"),
            minWidth: 120,
          },
          {
            prop: "nameChi",
            lable: this.language("shopBannerForm.nameChi"),
            minWidth: 190,
          },
          {
            prop: "nameEng",
            lable: this.language("shopBannerForm.nameEng"),
            minWidth: 190,
          },
          {
            minWidth: 120,
            prop: "status",
            lable: this.language("shopBannerForm.status"),
            type: "tag",
            options: {
              // 0: {
              //   tagType: "success",
              //   text: this.language("shopBannerForm.submit"),
              // },
              1: {
                tagType: "success",
                text: this.language("shopBannerForm.approved"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopBannerForm.rejected"),
              },
            },
          },
          {
            prop: "order",
            lable: this.language("shopBannerForm.order"),
            minWidth: 100,
          },
          {
            prop: "display",
            minWidth: 110,
            lable: this.language("shopBannerForm.display"),
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("shopBannerForm.visible"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopBannerForm.invisible"),
              },
            },
          },
          {
            minWidth: 100,
            prop: "webImg",
            lable: "WebImg",
            type: "img",
            urlPropName: "webImg",
            sourceUrlPropName: "webImg",
            imgCompressParams: "?x-oss-process=image/resize,w_600",
            w: 40,
            h: 40,
          },
          {
            minWidth: 100,
            prop: "appImg",
            lable: "AppImg",
            type: "img",
            urlPropName: "appImg",
            sourceUrlPropName: "appImg",
            imgCompressParams: "?x-oss-process=image/resize,w_600",
            w: 40,
            h: 40,
          },
          // {
          //   minWidth: 110,
          //   lable: this.language("shopBanners.linkType"),
          //   prop: "hrefType",
          //   render: (rows) => {
          //     if (rows.linkTo) {
          //       let linkTo = JSON.parse(rows.linkTo);
          //       return linkTo.articleType;
          //     }
          //   },
          // },
          {
            minWidth: 300,
            lable: this.language("shopBanners.linkContent"),
            prop: "hrefContent",
            render: (rows) => {
              if (rows.linkTo) {
                let linkTo = JSON.parse(rows.linkTo);
                return linkTo.articleName + "  id:" + linkTo.articleId;
              }
            },
          },
            {
            prop: "startTime",
            lable: this.language("shopBannerForm.startTime"),
            minWidth: 200,
          },
            {
            prop: "endTime",
            lable: this.language("shopBannerForm.endTime"),
            minWidth: 200,
          },
          {
            prop: "createTime",
            lable: this.language("shopBannerForm.createTime"),
            minWidth: 200,
          },
        ],
        buttons: [],
      },
      params: {},
      refeshTable: -1,
      dialog: false,
      results: 0,
      dataArr: [],
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      editData: {},
      shopData: {},
      buttonsWidth: 0,
    };
  },
  methods: {
    open() {
      this.dialog = true;

      this.editData = {
        shopNum: this.shopData.shopNum,
        mchShopNum: this.shopData.shopNum,
      };
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    getData(e) {
      e.shopNum = this.shopData.shopNum;
      e.mchShopNum = this.shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/shop/banner/query", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;

          this.$message.error(err.response.data.message);
        });
    },
    success() {
      this.getData(this.form);
      this.dialog = false;
    },
    delete(row) {
      this.$confirm(
        this.language("common.deletePermanentTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do("admin/merchant/shop/banner/delete", { id: row.id })
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopBannerForm.success"),
              });
              this.getData(this.form);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    edit(row) {
      this.ccRequest
        .do("admin/merchant/shop/banner/get", {
          id: row.id,
        })
        .then((res) => {
          this.editData = { ...res };
          this.dialog = true;
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.shopData = this.$shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });

    if (this.$menuList["SIS-ShopDisplay-Campaign-Edit"]) {
      this.table.buttons.push({
        name: this.language("shopBannerForm.edit"),
        click: (row, index) => {
          this.edit(row);
        },
      });
      this.buttonsWidth = 80;
    }
    if (this.$menuList["SIS-ShopDisplay-Campaign-Delete"]) {
      this.table.buttons.push({
        name: this.language("shopBannerForm.delete"),
        click: (row, index) => {
          this.delete(row);
        },
      });
      this.buttonsWidth = 80;
    }
  },
};
</script>
<style >
</style>
<style scoped lang="scss">
.button_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.count_tips {
  margin: 10px 0 20px 0;
  display: flex;
  justify-content: space-between;
  font-size: $sbuTitle;
  font-weight: 600;
}
</style>